import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=1c87c422&scoped=true"
var script = {}
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=1c87c422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c87c422",
  null
  
)

export default component.exports